<template>
  <section class="mini-login">
    <login-form
      :language="language"
      :login-disabled="loginDisabled"
      v-show="hasLicense"
      :LicenseMsg="LicenseMsg"
      :service-url="serviceUrl"
    ></login-form>
  </section>
</template>

<script>
import loginForm from './login-form'
import Api from 'api/api'

export default {
  name: 'miniLogin',
  components: {
    loginForm
  },
  data () {
    return {
      loginDisabled: false,
      LicenseMsg: {
        allowLogin: true,
        expireDate: '',
        expireMsg: '',
        noLicense: false
      },
      language: this.$storage.get('portal_language') || '', // 语言这里有待优化，暂时根据之前本地存的语言，不存在就默认语言中文
      hasLicense: false,
      serviceUrl: ''
    }
  },
  created () {
    this._getLicenseInfo()
  },
  mounted () {
    this.serviceUrl = window.location.href
  },
  methods: {
    _getLicenseInfo () {
      Api.login
        .getLicenseInfo()
        .then(res => {
          this.LicenseMsg = res.data
          if (res.data) {
            this.hasLicense = true
          } else {
            this.hasLicense = false
          }
        })
    }
  }
}
</script>

<style lang="less" scoped>
  .mini-login{
    width:400px;
    height:440px;
  }
</style>
